import { sankeyLinkHorizontal } from 'd3-sankey';
import * as d3 from 'd3';
import {computeHovered} from './computeHovered';

export function sankeyLayer(selection, props) {
  const {
    nodes,
    links,
    margin,
    innerWidth,
    labelPadding,
    colorScheme,
    pre
  } = props;

  let container = selection.selectAll('.container').data([null]);

  let hover = (hoveredNode) => {
    d3.select("#regional-sankey").attr("class", "hovered");
    let hovered = computeHovered(nodes, links, hoveredNode, innerWidth);

    for (var i = 0; i < hovered.links.length; i++) {
      d3.select("#" + (hovered.links[i].source.name + '-' + hovered.links[i].target.name).replace(/[^A-Z0-9]/ig, "_"))
        .attr("class", "active");
    }

    for (var i = 0; i < hovered.nodes.length; i++) {
      d3.select("#" + (hovered.nodes[i].name).replace(/[^A-Z0-9]/ig, "_"))
        .attr("class", "node-rect active");
    }

    for (var i = 0; i < hovered.nodes.length; i++) {
      d3.select("#t" + (hovered.nodes[i].name).replace(/[^A-Z0-9]/ig, "_"))
        .attr("class", "node-label active");
    }
  }

  let unHover = (hoveredNode) => {
    d3.select("#regional-sankey").attr("class", null);
    let hovered = computeHovered(nodes, links, hoveredNode, innerWidth);

      for (var i = 0; i < hovered.links.length; i++) {
        d3.select("#" + (hovered.links[i].source.name + '-' + hovered.links[i].target.name).replace(/[^A-Z0-9]/ig, "_"))
          .attr("class", null);
      }

      for (var i = 0; i < hovered.nodes.length; i++) {
        d3.select("#" + (hovered.nodes[i].name).replace(/[^A-Z0-9]/ig, "_"))
          .attr("class", "node-rect");
      }

      for (var i = 0; i < hovered.nodes.length; i++) {
        d3.select("#t" + (hovered.nodes[i].name).replace(/[^A-Z0-9]/ig, "_"))
          .attr("class", "node-label");
      }
  }

  let correctedMargin = margin.left + ((innerWidth + margin.left + margin.right)/0.9) * 0.1;

  container = container
    .enter().append('g')
      .attr('class', 'container')
    .merge(container)
      .attr('transform', `translate(${correctedMargin},${margin.top})`);

  const nodeRects = container.selectAll('.node-rect').data(nodes);
  nodeRects
    .enter().append('rect')
      .attr('class', 'node-rect')
      .attr('id', d => pre + d.name.replace(/[^A-Z0-9]/ig, "_"))
    .merge(nodeRects)
      .attr('x', d => d.x0)
      .attr('y', d => d.y0)
      .attr('height', d => d.y1 - d.y0)
      .attr('width', d => d.x1 - d.x0)
      .on('mouseover', hover)
      .on('mouseout', unHover);
  nodeRects.exit().remove();

  const linkPaths = container.selectAll('path').data(links);
  linkPaths
    .enter().append('path')
      .attr('id', (d) => pre + (d.source.name + '-' + d.target.name).replace(/[^A-Z0-9]/ig, "_"))
      .attr('class', (d) => d.class)
      .attr('fill', 'none')
      .attr('stroke', (d) => colorScheme(d.root))
      .style('opacity', 0.7)
      .attr('pointer-events', 'none')
    .merge(linkPaths)
      .attr('stroke-width', d => d.width)
      .attr('d', sankeyLinkHorizontal());
  linkPaths.exit().remove();

  const presentLabel = name => name.replace(/ origins/, '');
  const leftSide = d => d.x0 < innerWidth / 2 - 50;
  const maxLabelSize = 12;
  const labelSize = d => {
    if (d.height === 0 || d.depth === 0) return 12;
    return (d.y1 - d.y0) > 5 ? (pre === "fg" ? 6 : 12) : (pre === "fg" ? 4 : 3);
  }
  const nodeLabels = container.selectAll('.node-label').data(nodes);
  nodeLabels
    .enter().append('text')
      .attr('id', d => pre + "t" + d.name.replace(/[^A-Z0-9]/ig, "_"))
      .attr('class', 'node-label')
    .merge(nodeLabels)
      .style('font-size', d => labelSize(d) + 'px')
      .attr('x', d =>
        leftSide(d)
          ? d.x0 - labelPadding * labelSize(d) / maxLabelSize
          : d.x1 + labelPadding * labelSize(d) / maxLabelSize
      )
      .attr('dy', '0.32em') // Centers the text vertically
      .attr('text-anchor', d =>
        leftSide(d)
          ? 'end'
          : 'start'
      )
      .attr('y', d => (d.y1 + d.y0) / 2)
      .text(d => presentLabel(d.name))
      .on('mouseover', hover)
      .on('mouseout', unHover);
  nodeLabels.exit().remove();
}



// WEBPACK FOOTER //
// ./src/Sankey/sankeyLayer.js